// API Configuration with automatic URL detection

const getApiUrl = () => {
  // Check for runtime config first (production mode with nginx)
  if (window._env_ && window._env_.REACT_APP_API_URL && !window._env_.REACT_APP_API_URL.includes('PLACEHOLDER')) {
    return window._env_.REACT_APP_API_URL;
  }

  // Check for build-time env var (development and production)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Production fallback - use relative paths (works with reverse proxy/domain routing)
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }

  // Development fallback - direct connection to backend with /api prefix
  return 'http://localhost:8547/api';
};

const getWsUrl = () => {
  // Check for runtime config first (production mode with nginx)
  if (window._env_ && window._env_.REACT_APP_WS_URL && !window._env_.REACT_APP_WS_URL.includes('PLACEHOLDER')) {
    return window._env_.REACT_APP_WS_URL;
  }

  // Check for build-time env var (development mode)
  if (process.env.REACT_APP_WS_URL) {
    return process.env.REACT_APP_WS_URL;
  }

  // Production fallback - relative WebSocket (domain-based routing)
  if (process.env.NODE_ENV === 'production') {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}/ws`;
  }

  // Development - direct connection to backend WebSocket (includes /ws path)
  return 'ws://localhost:8547/ws';
};

export const API_URL = getApiUrl();
export const WS_URL = getWsUrl();

const config = {
  API_URL,
  WS_URL
};

export default config;